import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectRespondent = (state) => state.journey || initialState;

const journeySelector = () =>
  createSelector(selectRespondent, (state) => state.journey);

export { journeySelector };
